import { Action } from '@ngrx/store';
import { NavigationNode } from '../../models';

export enum AppActionTypes {
  Error = '[App] Error',
  UpdatePageTitle = '[App] Update Page Title'
}

export class Error implements Action {
  readonly type = AppActionTypes.Error;
  constructor(public payload: any) { }
}

export class UpdatePageTitle implements Action {
  readonly type = AppActionTypes.UpdatePageTitle;
  constructor(public payload: any) { }
}
export type AppActions = Error | UpdatePageTitle;



// WEBPACK FOOTER //
// ./src/app/core/store/actions/app.actions.ts